import Component from '../abstracts/Component';
import InfiniteScrollLogic from '../businessLogic/InfiniteScrollLogic';
import FiltersLogic from '../businessLogic/FiltersLogic';
import SortByComponent from '../components/SortByComponent';

export default class ListingComponent extends Component {
	
  get SELECTORS() {
    return {
      main: '.js-filter-bar'
    }
  }
	  
  constructor() {
	  super();
  }
  
  bindEvents() {
    this.$on('click.filterBar', this.filterBar, 'body', this.SELECTORS.main, this);	   
  }
  
  filterBar(e) {
  	if($('#filters-box.show').length > 0 || $('#sortby-box.show').length > 0) {
      let ctx = e.event.data;
      if (window.matchMedia('(min-width:767px)').matches) {
        ctx.FiltersLogic = new FiltersLogic(this);
        ctx.FiltersLogic.forceClose();
        ctx.SortByComponent = new SortByComponent(this);
        ctx.SortByComponent.forceClose();
      }
  	}
  }
  
  render() {
	  this.log('Rendering...');
	  this.InfiniteScrollLogic = new InfiniteScrollLogic(this);
	  this.InfiniteScrollLogic.render();
	  this.FiltersLogic = new FiltersLogic(this);
	  this.FiltersLogic.render();
	  this.bindEvents();
  }
  
}
